export default "__VITE_ASSET__D$l$DcO4__"